export class ResourceBlockerDetail {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "statusMessageKey",
            "baseName": "statusMessageKey",
            "type": "ResourceBlockerType",
            "format": ""
        },
        {
            "name": "statusMessage",
            "baseName": "statusMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "ResourceBlockerGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceBlockerDetail.attributeTypeMap;
    }
    constructor() {
    }
}
